exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na.contact-staff {\n  border-radius: 11px;\n  padding: 10px 25px;\n  display: inline-block;\n  text-align: center;\n  -webkit-box-shadow: 0 2px #cccccc;\n          box-shadow: 0 2px #cccccc;\n  border: 1px solid gray;\n}\n@media (max-width: 991.98px) {\na.contact-staff {\n    padding: 5px 15px;\n}\n}\nsection.main-content ul li {\n  list-style: none;\n  text-align: left;\n  margin-top: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/jobPost/JobPost.vue
// module id = 2317
// module chunks = 0